<template>
    <ui-crud title="Daily Briefings" subtitle="A list of daily briefings for this package" ref="crud"
             :fetch="fetch" :pipe-with="pipeItems" :group-by="groupByStatus">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.formattedDate}`"
                :subtitle="`${item.givenByName}`"
                :metadata="`${item.numberOfAttendees} attendee`+(item.numberOfAttendees!==1?'s':'')"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <daily-briefings-form :package-reference="packageReference" :package-name="packageName" :add-item="addItem"
                                  :contacts="contacts"></daily-briefings-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <daily-briefings-form :package-reference="packageReference" :package-name="packageName" :item="selectedItem"
                                  :contacts="contacts" :edit="setEditMode"></daily-briefings-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem }">
            <daily-briefings-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" @print="print"
                                  :package-reference="packageReference" :package-name="packageName" :contacts="contacts"
                                  :add-item="addItem"></daily-briefings-show>
        </template>
    </ui-crud>
</template>

<script>
import {Contact, DailyBriefing} from "@models";
import DailyBriefingsForm from "./DailyBriefingsForm.vue";
import DailyBriefingsShow from "./DailyBriefingsShow.vue";
import UiInput from "../../ui/UiInput.vue";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import UiCrud from "../../ui/UiCrud.vue";
import moment from "moment/moment";

export default {
    components: {UiCrud, UiCrudCard, UiInput, DailyBriefingsShow, DailyBriefingsForm},
    props: {
        packageReference: null,
        packageName: null,
        admin: Boolean,
        showWhenLoaded : null
    },
    data() {
        return {
            search: '',
            contacts: {data: [], loaded: false},
            items: [],
        }
    },
    methods: {
        async fetch(itemId) {
            this.loaded = false
            this.items = await DailyBriefing.all(this.packageReference)
            if (itemId) {
                this.$refs.crud.selectItem(this.items.find((i) => i.id === itemId))
            } else if (this.items.length) {
                this.$refs.crud.selectItem(this.items[0])
            }
            this.loaded = true
            return this.items;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.\/-]+/).filter((i) => i!=='')
            if (query.length) {
                return this.items.filter((induction) => {
                    return query.every((token) => {
                        return induction.tokens.includes(token);
                    })
                });
            }
            return this.items;
        },
        groupByStatus(item) {
            return item.status;
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            },100)
                        }
                    )
                }
                document.body.appendChild(this.iframe);
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
    },
    async mounted() {
        this.contacts.data = await Contact.all()
        this.contacts.loaded = true;
        if (this.showWhenLoaded) {
            this.$refs.crud.fetch(this.showWhenLoaded)
        }
    }
}
</script>
